import React from 'react';
import {
  AnnualRevenueValueBlock,
  SliderCalculatorForAnnualRevenueContainer,
  SliderCalculatorInputsContainer,
  SliderCalculatorValueContainer,
  ValueBackgroundImage,
} from './SliderCalculatorForAnnualRevenue.styles';
import CalculatorSliderInput from 'src/molecules/Shared/2024_Q1_people_magic/Calculator/Calculator.slider';
import CalculatorInput from 'src/molecules/Shared/2024_Q1_people_magic/Calculator/Calculator.input';
import TextureOverlay from 'src/molecules/Standard/Shared/TextureOverlay/TextureOverlay';
import Paragraph from 'src/elements/typography/paragraph';
import Heading from 'src/elements/typography/heading';
import useCalculatorController from 'src/hooks/useCalculatorController';

const SliderCalculatorForAnnualRevenue = (): JSX.Element => {
  const {
    memberNumber,
    sliderIndexValue,
    setSliderIndexValue,
    subscriptionValue,
    setSubscriptionValue,
    courseValue,
    setCourseValue,
    annualRevenue,
  } = useCalculatorController({
    eventLabel: 'ROI Calculator Interaction Standard',
    initialSliderIndexValue: 1,
  });

  return (
    <SliderCalculatorForAnnualRevenueContainer>
      <SliderCalculatorInputsContainer>
        <CalculatorSliderInput
          label='Number of Members'
          max={9}
          min={0}
          step={1}
          value={sliderIndexValue}
          valueLabel={memberNumber}
          onChange={setSliderIndexValue}
        />
        <CalculatorInput
          max={10000}
          min={0}
          value={subscriptionValue}
          label='Subscription'
          tooltipText='$48/month is the average price of a paid membership on Mighty.'
          valueLabel='per month'
          onChange={setSubscriptionValue}
        />
        <CalculatorInput
          max={10000}
          min={0}
          value={courseValue}
          label='Course Or Event'
          tooltipText='$500 is the average price for a one-time fee, like for a course or event, on Mighty.'
          valueLabel='One-time Fee'
          onChange={setCourseValue}
        />
      </SliderCalculatorInputsContainer>
      <SliderCalculatorValueContainer>
        {annualRevenue !== null ? (
          <AnnualRevenueValueBlock>
            <Heading
              align='center'
              weight={800}
              fontFamily='Mulish'
              standardSize='3.375'
              text={`$${annualRevenue}`}
            />
            <Paragraph
              standardSize='1'
              align='center'
              weight={400}
              className='annual-revenue-text'
              text={`Annual Revenue`}
            />
          </AnnualRevenueValueBlock>
        ) : (
          <Paragraph
            size='1.125rem'
            align='center'
            weight={800}
            text={`Our calculator maxes out just under $1B—but that's a limit on the tool, not your potential.`}
          />
        )}
        <ValueBackgroundImage>
          <TextureOverlay opacity={0.24} />
        </ValueBackgroundImage>
      </SliderCalculatorValueContainer>
    </SliderCalculatorForAnnualRevenueContainer>
  );
};

export default SliderCalculatorForAnnualRevenue;
